/* ============================================================
   CiemnaSzyba — drobne UI
   Szacowana dostawa, wysokość nagłówka, sticky CTA, licznik koszyka,
   poświata w hero.
   ============================================================ */
(function () {
  "use strict";

  /* ---- szacowana dostawa -------------------------------------
     ⚠ MUSI zostać po stronie klienta. Shopify cache'uje HTML
     storefrontu, więc `'now' | date` w Liquid zamarza i klient
     zobaczy termin z przeszłości. Okno: dziś+7 … dziś+16.

     ⚠ Format przez `Intl`, NIE przez słownik miesięcy. Do 31.08 stała tu
     tablica 12 polskich nazw w DOPEŁNIACZU („września") sklejana ręcznie.
     Dla EN, DE i CS łamał się jednocześnie słownik, szyk i przypadek,
     a czeski ma własną deklinację — słownikiem tego nie da się załatać.
     Kryterium akceptacji zmiany: polski wynik ma zostać IDENTYCZNY ze starym
     („12–21 września", „28 sierpnia – 6 września").

     Fallback bez `formatRange` (starsze Safari) odtwarza dokładnie stary szyk:
     przy jednym miesiącu skraca do „12–21 września", przy dwóch daje pełne
     obie daty. Nazwa miesiąca i tak idzie z `Intl`, więc jest zlokalizowana. */
  function localeCode() {
    var l = document.documentElement.getAttribute("lang");
    if (!l && window.Shopify && window.Shopify.locale) l = window.Shopify.locale;
    return l || "pl";
  }

  function deliveryText() {
    var a = new Date(); a.setDate(a.getDate() + 7);
    var b = new Date(); b.setDate(b.getDate() + 16);
    try {
      var fmt = new Intl.DateTimeFormat(localeCode(), { day: "numeric", month: "long" });
      /* ⚠ Okno przełomu roku idzie ścieżką ręczną, NIE przez formatRange.
         Przy różnych latach `formatRange` sam dokleja rok („23 grudnia 2026 –
         1 stycznia 2027"), bo bez niego zakres byłby dwuznaczny. Dla nas to
         regresja: stary kod nigdy roku nie pokazywał, a termin dostawy i tak
         jest zawsze w najbliższych 16 dniach, więc rok nic nie wnosi.
         Wykryte przemieceniem wszystkich 365 dni startowych — dotyczy 9 dni
         w roku (23–31 grudnia). Dwie próbki z polecenia tego nie pokazują. */
      if (typeof fmt.formatRange === "function" && a.getFullYear() === b.getFullYear()) {
        return fmt.formatRange(a, b);
      }
      if (a.getMonth() === b.getMonth()) return a.getDate() + "–" + fmt.format(b);
      return fmt.format(a) + " – " + fmt.format(b);
    } catch (e) {
      /* Ostatnia deska ratunku — same liczby, bez nazwy miesiąca.
         Lepsze niż wyjątek, który zabiłby resztę initDelivery. */
      return a.getDate() + "–" + b.getDate();
    }
  }

  function initDelivery() {
    CS.$$("[data-cs-delivery]").forEach(function (el) {
      el.textContent = CS.t("delivery_prefix", "Szacowana dostawa: ") + deliveryText();
    });
  }

  /* ---- wysokość nagłówka -------------------------------------
     Źródło miało na sztywno scroll-padding-top:92px, co zakłada
     widoczny pasek informacyjny. Po jego ukryciu kotwica
     #konfigurator uciekała o ~40 px. Mierzymy realnie. */
  function initHeaderHeight() {
    var header = document.querySelector("[data-cs-header]");
    if (!header) return null;
    function apply() {
      document.documentElement.style.setProperty("--cs-header-h", Math.round(header.getBoundingClientRect().height) + "px");
    }
    apply();
    if (typeof ResizeObserver === "undefined") return null;
    var ro = new ResizeObserver(apply);
    ro.observe(header);
    return ro;
  }

  /* ---- sticky CTA (mobile) -----------------------------------
     PRZYCZYNA „nie działa na telefonie”: pasek renderował się poprawnie — fixed,
     z-index 150, żaden przodek nie łamał `position: fixed`, nic go nie zakrywało
     — ale przy `bottom: 0` wchodził POD pasek podglądu motywu Shopify. Zmierzone:
     68 z 72 px wysokości było zasłonięte, czyli w podglądzie wyglądał na nieobecny.
     Stąd --cs-preview-h: mierzymy #PBarNextFrameWrapper i podnosimy pasek
     dokładnie o jego wysokość. Na opublikowanym sklepie tego paska nie ma
     i offset wynosi 0, więc produkcja zachowuje się jak dotąd.

     Przy okazji poprawki zachowania:
     • odniesieniem jest przycisk „Dodaj do koszyka”, a nie dolna krawędź CAŁEGO
       formularza;
     • pasek jest widoczny zawsze, gdy tego przycisku NIE ma w kadrze — także
       gdy stoi się NAD nim, w selektorze auta (patrz komentarz przy update());
     • pasek chowa się, gdy w kadr wchodzi stopka, żeby jej nie zasłaniać
       (wcześniej zostawał widoczny do samego końca strony). */
  function initStickyCta() {
    var bar = document.querySelector("[data-cs-sticky]");
    var form = document.getElementById("konfigurator");
    if (!bar || !form) return function () {};
    var cta = form.querySelector("[data-cs-submit]") || form;
    var footer = document.querySelector(".cs-footer");

    /* Pasek podglądu motywu jest fixed przy dolnej krawędzi i nachodziłby na CTA.
       Na opublikowanym sklepie go nie ma, więc wartość zostaje 0. */
    function applyPreviewOffset() {
      var pb = document.getElementById("PBarNextFrameWrapper");
      var h = pb ? Math.round(pb.getBoundingClientRect().height) : 0;
      bar.style.setProperty("--cs-preview-h", h + "px");
    }

    /* ⚠ Warunkiem jest „przycisku NIE MA w kadrze", w OBIE strony — nie
       „przycisk zjechał za górną krawędź".
       BYŁO `cta.getBoundingClientRect().bottom < 0`, czyli pasek pokazywał się
       dopiero PO minięciu przycisku. Przez cały selektor auta — najdłuższy
       fragment strony, na którym klient stoi najdłużej — przycisk był jeszcze
       NIŻEJ, więc na ekranie nie było żadnego CTA.
       Teraz pasek znika wyłącznie wtedy, gdy prawdziwy przycisk jest widoczny;
       nad nim i pod nim jest obecny.
       Test bez przewijania (podgląd nie renderuje): ujemny `margin-top` na
       `main` przesuwa layout, po czym `dispatchEvent(new Event("scroll"))`
       wymusza przeliczenie — margines nie tworzy kontekstu nakładania. */
    function update() {
      var r = cta.getBoundingClientRect();
      var ctaWKadrze = r.bottom > 0 && r.top < window.innerHeight;
      var stopkaWKadrze = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.hidden = !(CS.isMobile() && !ctaWKadrze && !stopkaWKadrze);
    }
    function onResize() { applyPreviewOffset(); update(); }

    applyPreviewOffset();
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", onResize);
    CS.mobileMQ.addEventListener("change", onResize);

    return function () {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", onResize);
      CS.mobileMQ.removeEventListener("change", onResize);
    };
  }

  /* ---- nawigacja pod hamburgerem (mobile) --------------------
     Rejestracja na [data-cs-burger], a nie na sekcji nagłówka — patrz §4.11
     PRZEKAZANIE: `mounted` w cs-core.js kluczuje WeakMap samym elementem,
     więc druga onSection na tym samym węźle byłaby po cichu pominięta. */
  function initNav(btn) {
    var header = btn.closest(".cs-header");
    var nav = header && header.querySelector("[data-cs-nav]");
    if (!header || !nav) return function () {};

    function otwarte() { return btn.getAttribute("aria-expanded") === "true"; }
    function ustaw(v) {
      if (v) {
        /* Docelowa wysokość animacji rozwijania. scrollHeight raportuje pełną
           treść mimo max-height: 0, więc mierzymy tuż przed otwarciem —
           animacja jedzie do realnej wysokości panelu, a nie do zgadywanej. */
        nav.style.setProperty("--cs-nav-h", nav.scrollHeight + "px");
      }
      btn.setAttribute("aria-expanded", v ? "true" : "false");
      header.classList.toggle("is-nav-open", v);
    }
    /* Focus wraca na przycisk, gdy zamykamy z klawiatury albo gdy fokus siedział
       w menu. Przy kliknięciu poza menu NIE odbieramy fokusu klikniętemu
       elementowi — to by walczyło z intencją użytkownika. */
    function zamknij(wymusFocus) {
      if (!otwarte()) return;
      var bylWSrodku = nav.contains(document.activeElement);
      ustaw(false);
      if (wymusFocus || bylWSrodku) btn.focus();
    }

    function onBtn() {
      if (otwarte()) { zamknij(true); return; }
      ustaw(true);
      /* Focus na pierwszym linku NATYCHMIAST, nie po animacji — w stanie
         otwartym visibility przełącza się bez opóźnienia. Odczyt offsetHeight
         wymusza przeliczenie stylu; bez niego focus() trafiłby jeszcze
         w element o visibility: hidden i zostałby zignorowany. */
      void nav.offsetHeight;
      var pierwszy = nav.querySelector("a");
      if (pierwszy) pierwszy.focus();
    }
    function onKey(e) { if (e.key === "Escape" || e.key === "Esc") zamknij(true); }
    function onDoc(e) { if (!header.contains(e.target)) zamknij(false); }
    function onNav(e) { if (e.target.closest("a")) zamknij(false); }
    /* Powrót na desktop zostawiłby aria-expanded="true" przy widocznej,
       poziomej nawigacji — mylące dla czytnika ekranu. */
    function onMQ() { if (!CS.mobileMQ.matches) zamknij(false); }

    btn.addEventListener("click", onBtn);
    document.addEventListener("keydown", onKey);
    document.addEventListener("click", onDoc);
    nav.addEventListener("click", onNav);
    CS.mobileMQ.addEventListener("change", onMQ);
    window.addEventListener("resize", onMQ, { passive: true });

    return function () {
      btn.removeEventListener("click", onBtn);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("click", onDoc);
      nav.removeEventListener("click", onNav);
      CS.mobileMQ.removeEventListener("change", onMQ);
      window.removeEventListener("resize", onMQ);
    };
  }

  /* ---- przełącznik kraju i języka ----------------------------
     ⚠ Rejestracja na WŁASNYM węźle `[data-cs-loc]`, nie na sekcji nagłówka —
     `[data-cs-burger]` jest już zajęty przez initNav, a `mount()` kluczuje
     `mounted` samym elementem i drugą rejestrację na tym samym węźle pomija
     bez śladu w konsoli (PRZEKAZANIE §4.11).

     ⚠ JS TYLKO OTWIERA I ZAMYKA PANEL. Przełączanie robi natywny
     `<button type="submit">` w `{% form 'localization' %}`, więc bez JS
     kontrolka dalej działa — panel jest wtedy po prostu zawsze widoczny
     w torze Tab, ale wybór kraju i języka pozostaje możliwy. */
  function initLoc(box) {
    var btn = box.querySelector("[data-cs-loc-btn]");
    /* ⚠ Panel NIE jest już potomkiem `box` — siedzi w <body>, bo tylko tam nie ma
       nad nim `backdrop-filter` nagłówka ani jego kontekstu układania (diagnoza
       w `snippets/cs-localization.liquid`). Szukamy go więc po `aria-controls`,
       nie przez `box.querySelector`. Ten sam atrybut wiąże je dla czytnika ekranu,
       więc nie ma tu drugiego źródła prawdy do rozjechania. */
    var panel = null;
    var idPanelu = btn && btn.getAttribute("aria-controls");
    if (idPanelu) panel = document.getElementById(idPanelu);
    if (!btn || !panel) return function () {};
    var zamkniecie = panel.querySelector("[data-cs-loc-close]");

    /* ---- zakładki --------------------------------------------------
       Kraj i język leżały wcześniej jedną listą: 1710 px treści w oknie 620 px,
       a pierwszy język na 26. pozycji, za dwudziestoma pięcioma krajami.
       Teraz są dwie zakładki, domyślnie otwarta „Język".
       ⚠ Zakładki przełącza WYŁĄCZNIE JS. Bez skryptu oba panele zostają
       widoczne (skrypt zdejmuje `hidden` z aktywnego i nakłada na drugi
       dopiero tutaj) — kontrolka działa wtedy tak jak przed tą zmianą. */
    var zakladki = CS.$$("[data-cs-loc-tab]", panel);
    var panele = CS.$$("[data-cs-loc-pane]", panel);

    function aktywnaZakladka() {
      return zakladki.filter(function (t) {
        return t.getAttribute("aria-selected") === "true";
      })[0] || zakladki[0];
    }
    function aktywnyPanel() {
      var t = aktywnaZakladka();
      if (!t) return panel;
      return document.getElementById(t.getAttribute("aria-controls")) || panel;
    }
    function pokazZakladke(cel) {
      zakladki.forEach(function (t) {
        var on = t === cel;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.classList.toggle("is-on", on);
        var p = document.getElementById(t.getAttribute("aria-controls"));
        if (p) p.hidden = !on;
      });
    }

    /* Opcje AKTYWNEJ zakładki — po nich chodzą strzałki, Home i End. */
    function opcje() {
      return CS.$$(".cs-loc__opt", aktywnyPanel());
    }
    /* Pełny pierścień pułapki focusu: krzyżyk, obie zakładki, opcje aktywnej.
       ⚠ Krzyżyk jest widoczny tylko na arkuszu dolnym — `offsetParent`
       odróżnia „ukryty przez display:none" od „jest, tylko poza kadrem". */
    function ogniska() {
      var t = [];
      if (zamkniecie && zamkniecie.offsetParent !== null) t.push(zamkniecie);
      t = t.concat(zakladki, opcje());
      return t;
    }
    function otwarty() { return btn.getAttribute("aria-expanded") === "true"; }

    /* Panel jest `position: fixed` w <body>, więc nie ma kotwicy w DOM i musi
       dostać współrzędne z prostokąta przycisku. Poniżej 900 px CSS nadpisuje je
       przez `inset: 0` (arkusz pełnoekranowy), więc ustawianie ich zawsze jest
       bezkosztowe i nie wymaga rozgałęzienia na breakpoint.
       ⚠ `documentElement.clientWidth`, nie `innerWidth` — przy poziomym
       przepełnieniu `innerWidth` bywa większy od szerokości okna (pułapka 17)
       i panel wyjechałby poza prawą krawędź. */
    function ustawPozycje() {
      var r = btn.getBoundingClientRect();
      var szer = document.documentElement.clientWidth;
      panel.style.setProperty("--cs-loc-top", Math.round(r.bottom + 8) + "px");
      panel.style.setProperty("--cs-loc-right",
        Math.max(8, Math.round(szer - r.right)) + "px");
    }

    function otworz() {
      ustawPozycje();
      panel.hidden = false;
      btn.setAttribute("aria-expanded", "true");
      window.addEventListener("scroll", ustawPozycje, { passive: true });
      window.addEventListener("resize", ustawPozycje);
      /* ⚠ Zaznaczona opcja AKTYWNEJ zakładki, nie pierwsza `.is-on` w całym
         panelu — ta druga siedziałaby w ukrytej liście krajów i `focus()`
         na elemencie w `[hidden]` nie robi nic, więc focus zostawałby na <body>. */
      var cel = aktywnyPanel().querySelector(".cs-loc__opt.is-on") || opcje()[0] || ogniska()[0];
      if (cel) cel.focus();
    }
    function zamknij(wroc) {
      panel.hidden = true;
      btn.setAttribute("aria-expanded", "false");
      window.removeEventListener("scroll", ustawPozycje);
      window.removeEventListener("resize", ustawPozycje);
      if (wroc) btn.focus();
    }

    function onBtn() { if (otwarty()) zamknij(true); else otworz(); }
    function onClose() { zamknij(true); }
    /* klik w samą warstwę (przyciemnione tło arkusza), nie w arkusz */
    function onPanel(e) { if (e.target === panel) zamknij(true); }
    /* ⚠ Przy zamknięciu klikiem POZA panelem focus może siedzieć w środku —
       na opcji, która za chwilę zniknie. Zostawiony tam przepada (przeglądarka
       zrzuca go na <body>) i użytkownik klawiatury traci miejsce w dokumencie.
       Dlatego: focus wraca na przycisk TYLKO wtedy, gdy był w panelu. Jeśli
       użytkownik kliknął myszą gdzie indziej, nie odbieramy mu tego miejsca. */
    /* ⚠ `box` to już tylko przycisk — panel stoi w <body>, więc bez drugiego
       warunku każdy klik w arkusz liczyłby się jako „poza" i zamykał panel
       zanim formularz zdążyłby wysłać. To samo dotyczy sprawdzenia, gdzie
       siedzi focus. */
    function wSrodku(el) {
      return box.contains(el) || panel.contains(el);
    }
    function onDoc(e) {
      if (!otwarty() || wSrodku(e.target)) return;
      zamknij(wSrodku(document.activeElement));
    }

    function onKey(e) {
      if (!otwarty()) return;
      var k = e.key;
      if (k === "Escape" || k === "Esc") { e.preventDefault(); zamknij(true); return; }
      var t = ogniska();
      if (!t.length) return;
      var i = t.indexOf(document.activeElement);

      /* ⚠ Strzałki chodzą po OPCJACH aktywnej zakładki, nie po całym pierścieniu.
         Gdyby liczyły się po `ogniska()`, strzałka w dół z ostatniej opcji
         wracałaby na krzyżyk i zakładki — a to jest lista wyboru, nie karuzela
         po całym oknie. Ze strzałki stojącej na zakładce wchodzimy w listę:
         to jedyne wyjście, bo Tab jest zajęty przez przechodzenie między
         zakładkami, a użytkownik klawiatury musi mieć jak sięgnąć do opcji. */
      var opc = opcje();
      if (k === "ArrowDown" || k === "ArrowUp") {
        e.preventDefault();
        if (!opc.length) return;
        var io = opc.indexOf(document.activeElement);
        if (io === -1) { opc[k === "ArrowDown" ? 0 : opc.length - 1].focus(); return; }
        var n = k === "ArrowDown" ? io + 1 : io - 1;
        if (n < 0) n = opc.length - 1;
        if (n >= opc.length) n = 0;
        opc[n].focus();
        return;
      }
      /* ⚠ Strzałki lewo/prawo przełączają zakładki — wzorzec ARIA dla tablist. */
      if ((k === "ArrowLeft" || k === "ArrowRight") && zakladki.indexOf(document.activeElement) !== -1) {
        e.preventDefault();
        var iz = zakladki.indexOf(document.activeElement);
        var nz = k === "ArrowRight" ? iz + 1 : iz - 1;
        if (nz < 0) nz = zakladki.length - 1;
        if (nz >= zakladki.length) nz = 0;
        pokazZakladke(zakladki[nz]);
        zakladki[nz].focus();
        return;
      }
      if (k === "Home") { e.preventDefault(); if (opc.length) opc[0].focus(); return; }
      if (k === "End") { e.preventDefault(); if (opc.length) opc[opc.length - 1].focus(); return; }
      /* pułapka focusu: Tab nie ma prawa wyjść poza otwarty panel */
      if (k === "Tab") {
        if (i === -1) { e.preventDefault(); t[0].focus(); return; }
        if (e.shiftKey && i === 0) { e.preventDefault(); t[t.length - 1].focus(); }
        else if (!e.shiftKey && i === t.length - 1) { e.preventDefault(); t[0].focus(); }
      }
    }

    function onTab(e) { pokazZakladke(e.currentTarget); }

    btn.addEventListener("click", onBtn);
    panel.addEventListener("click", onPanel);
    if (zamkniecie) zamkniecie.addEventListener("click", onClose);
    zakladki.forEach(function (t) { t.addEventListener("click", onTab); });
    document.addEventListener("click", onDoc);
    document.addEventListener("keydown", onKey);

    /* ⚠ Stan początkowy nakłada JS, a nie Liquid. Gdyby `hidden` na liście
       krajów stało w markupie, przy wyłączonym skrypcie kraju nie dałoby się
       zmienić w ogóle — a cała kontrolka jest z założenia sprawna bez JS
       (przełącza natywny `<button type="submit">` w `{% form 'localization' %}`).
       Bez skryptu widać więc obie listy: dłużej, ale kompletnie. */
    if (zakladki.length) pokazZakladke(aktywnaZakladka());

    return function () {
      btn.removeEventListener("click", onBtn);
      panel.removeEventListener("click", onPanel);
      if (zamkniecie) zamkniecie.removeEventListener("click", onClose);
      zakladki.forEach(function (t) { t.removeEventListener("click", onTab); });
      document.removeEventListener("click", onDoc);
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("scroll", ustawPozycje);
      window.removeEventListener("resize", ustawPozycje);
      panele.forEach(function (p) { p.hidden = false; });
    };
  }

  CS.onSection("[data-cs-loc]", initLoc);

  /* ---- podpowiedź kraju dostawy ------------------------------
     Sklep jest na planie Basic, a wykrywanie rynku po geolokalizacji to funkcja
     Plusa — każdy odwiedzający ląduje na rynku Poland i widzi złotówki.
     Czytamy więc strefę czasową przeglądarki: żadnego GeoIP, żadnej usługi
     zewnętrznej, żadnego identyfikatora, więc i żadnej zgody na cookie.

     ⚠ To jest PROPOZYCJA, nie akcja. Nigdy nie przełączamy sami — powód
     w `snippets/cs-geo-hint.liquid`, w skrócie: wszystkie dotychczasowe
     zamówienia zagraniczne to Polacy za granicą płacący w złotówkach. */
  var GEO_KLUCZ = "cs_geo_hint_v1";

  /* Tylko 25 krajów, do których sklep wysyła. Strefa spoza listy = cisza. */
  var GEO_STREFY = {
    "Europe/Warsaw": "PL",
    "Europe/Berlin": "DE", "Europe/Busingen": "DE", "Europe/Vienna": "AT",
    "Europe/Brussels": "BE", "Europe/Sofia": "BG", "Europe/Zagreb": "HR",
    "Europe/Prague": "CZ", "Europe/Copenhagen": "DK", "Europe/Tallinn": "EE",
    "Europe/Helsinki": "FI", "Europe/Mariehamn": "FI", "Europe/Paris": "FR",
    "Europe/Athens": "GR", "Europe/Budapest": "HU", "Europe/Dublin": "IE",
    "Europe/Rome": "IT", "Europe/Riga": "LV", "Europe/Vilnius": "LT",
    "Europe/Luxembourg": "LU", "Europe/Amsterdam": "NL", "Europe/Lisbon": "PT",
    "Atlantic/Azores": "PT", "Atlantic/Madeira": "PT", "Europe/Bucharest": "RO",
    "Europe/Bratislava": "SK", "Europe/Ljubljana": "SI", "Europe/Madrid": "ES",
    "Africa/Ceuta": "ES", "Atlantic/Canary": "ES", "Europe/Stockholm": "SE"
  };

  /* Kraj → OPUBLIKOWANY język, który mu odpowiada. Kraje spoza tej mapy
     (NL, DK, SE, PT, GR…) zostają przy bieżącym języku — angielski je obsłuży.
     ⚠ AT, BE i LU celowo NIE są tu wpisane, choć `de` i `fr` są opublikowane:
     lista pochodzi wprost z polecenia i jej rozszerzenie to decyzja Alana,
     nie moja. */
  var GEO_JEZYKI = { DE: "de", CZ: "cs", SK: "sk", LT: "lt", FR: "fr", IT: "it", ES: "es" };

  /* ⚠ Czysta funkcja, bez dotykania DOM — wystawiona na `CS` WYŁĄCZNIE po to,
     żeby kryteria odbioru dało się zmierzyć wywołaniem, zamiast podmieniać
     `Intl.DateTimeFormat` i `navigator.language` przed startem skryptu.
     Zwraca kod kraju do zaproponowania albo null wraz z powodem ciszy. */
  function geoKraj(strefa, jezykPrzegladarki, krajBiezacy) {
    var kraj = GEO_STREFY[strefa];
    if (!kraj) return { kraj: null, powod: "strefa spoza listy 25 krajow" };
    /* Polska przeglądarka + obca strefa = niemal na pewno Polak za granicą.
       Chce złotówek. Zostawiamy go w spokoju. */
    if (/^pl\b/i.test(String(jezykPrzegladarki || ""))) {
      return { kraj: null, powod: "przegladarka po polsku — diaspora" };
    }
    if (kraj === krajBiezacy) return { kraj: null, powod: "kraj juz ustawiony" };
    return { kraj: kraj, powod: null };
  }
  CS.geoKraj = geoKraj;

  function initGeo(box) {
    var pusty = function () {};
    var tak = box.querySelector("[data-cs-geo-accept]");
    var nie = box.querySelector("[data-cs-geo-decline]");
    var poleJezyk = box.querySelector("[data-cs-geo-locale]");
    var elKraj = box.querySelector("[data-cs-geo-country]");
    var elWaluta = box.querySelector("[data-cs-geo-currency]");
    if (!tak || !nie || !elKraj || !elWaluta) return pusty;

    function zapamietaj(decyzja) {
      try { localStorage.setItem(GEO_KLUCZ, decyzja); } catch (e) {}
    }
    function juzZdecydowal() {
      try { return !!localStorage.getItem(GEO_KLUCZ); } catch (e) { return false; }
    }
    /* ⚠ localStorage bywa niedostępny (tryb prywatny, zablokowane dane witryny)
       i sam ODCZYT rzuca wtedy wyjątkiem. Bez try/catch pasek wywracałby
       inicjalizację całego cs-ui.js. */
    if (juzZdecydowal()) return pusty;

    var strefa = "";
    try { strefa = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch (e) {}
    var jezyk = (navigator.languages && navigator.languages[0]) || navigator.language || "";
    var biezacy = (window.Shopify && window.Shopify.country) || "";

    var wynik = geoKraj(strefa, jezyk, biezacy);
    if (!wynik.kraj) return pusty;

    /* Słownik krajów pochodzi z Shopify, nie z tablicy w kodzie — dołożenie
       kraju do rynku nie wymaga ruszania tego pliku. */
    var kraje = [];
    try {
      var el = document.querySelector("[data-cs-geo-kraje]");
      if (el) kraje = JSON.parse(el.textContent);
    } catch (e) {}
    var dane = null;
    for (var i = 0; i < kraje.length; i++) {
      if (kraje[i].iso === wynik.kraj) { dane = kraje[i]; break; }
    }
    if (!dane) return pusty;   /* kraj wykryty, ale sklep go nie obsługuje */

    /* Nazwa kraju W JĘZYKU PRZEGLĄDARKI, nie strony. Bez automatycznego
       przekierowania po `Accept-Language` (sprawdzone 04.09: sklep go nie ma)
       Niemiec ląduje na wersji polskiej — „Deutschland" zrozumie, „Niemcy" nie. */
    var nazwa = dane.nazwa;
    try {
      var dn = new Intl.DisplayNames([jezyk], { type: "region" });
      nazwa = dn.of(wynik.kraj) || dane.nazwa;
    } catch (e) {}

    elKraj.textContent = nazwa;
    elWaluta.textContent = dane.waluta || dane.waluta_iso || "";
    tak.value = wynik.kraj;

    /* ⚠ Pole języka ustawiamy ZAWSZE, także dla krajów bez odpowiednika
       (NL, DK, SE, PT, GR…) — wtedy z powrotem na język bieżący. Samo
       „ustaw, gdy jest odpowiednik" wystarcza przy jednym przebiegu, bo Liquid
       renderuje tam język strony, ale przy ponownej inicjalizacji (edytor
       motywu wysyła `shopify:section:load`) zostawałaby wartość z poprzedniego
       przebiegu. Zmierzone: po remoncie DE→SE w polu siedziało `de`, czyli
       Szwed dostałby niemiecki. */
    if (poleJezyk) {
      poleJezyk.value = GEO_JEZYKI[wynik.kraj]
        || (window.Shopify && window.Shopify.locale)
        || poleJezyk.value;
    }

    /* ⚠ Pasek siada pod DOLNĄ KRAWĘDZIĄ nagłówka, a nie na jego wysokości.
       Zmierzone: `--cs-header-h` to 63 px, ale nad nagłówkiem stoi pasek
       informacyjny i realny dół wypada na 100 px — `top: 63px` nachodziło
       na nagłówek. Pasek informacyjny jest osobną sekcją poza sticky, więc
       odjeżdża przy przewijaniu i ta liczba się zmienia. */
    function ustawGore() {
      var wrap = document.querySelector(".cs-header-wrap") || document.querySelector(".cs-header");
      if (!wrap) return;
      var dol = Math.max(0, Math.round(wrap.getBoundingClientRect().bottom));
      box.style.setProperty("--cs-geo-top", dol + "px");
    }
    ustawGore();

    box.hidden = false;
    /* Klasa, nie `hidden`, steruje animacją wsunięcia — `hidden` zdejmuje
       element z układu, więc przejście nie miałoby z czego wystartować. */
    requestAnimationFrame(function () { box.classList.add("is-on"); });
    window.addEventListener("scroll", ustawGore, { passive: true });
    window.addEventListener("resize", ustawGore);

    function odrzuc() {
      zapamietaj("nie");
      box.classList.remove("is-on");
      box.hidden = true;
      window.removeEventListener("scroll", ustawGore);
      window.removeEventListener("resize", ustawGore);
    }
    function onTak() { zapamietaj("tak"); }   /* formularz idzie dalej sam */
    function onKey(e) {
      if (box.hidden) return;
      if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); odrzuc(); }
    }

    nie.addEventListener("click", odrzuc);
    tak.addEventListener("click", onTak);
    document.addEventListener("keydown", onKey);
    return function () {
      nie.removeEventListener("click", odrzuc);
      tak.removeEventListener("click", onTak);
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("scroll", ustawGore);
      window.removeEventListener("resize", ustawGore);
    };
  }

  CS.onSection("[data-cs-geo]", initGeo);

  CS.onSection("[data-cs-burger]", initNav);

  /* ---- poświata w hero ---------------------------------------
     Czysta dekoracja. Wyłączona przy prefers-reduced-motion
     i na urządzeniach bez precyzyjnego wskaźnika. */
  function initHeroGlow() {
    var glow = document.querySelector("[data-cs-glow]");
    if (!glow) return function () {};
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return function () {};
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return function () {};

    var host = glow.closest("section");
    if (!host) return function () {};

    function move(e) {
      var r = host.getBoundingClientRect();
      glow.style.opacity = "1";
      glow.style.transform = "translate3d(" + (e.clientX - r.left) + "px," + (e.clientY - r.top) + "px,0)";
    }
    function leave() { glow.style.opacity = "0"; }

    host.addEventListener("pointermove", move, { passive: true });
    host.addEventListener("pointerleave", leave, { passive: true });
    return function () {
      host.removeEventListener("pointermove", move);
      host.removeEventListener("pointerleave", leave);
    };
  }

  /* ---- tickery (mobile) --------------------------------------
     Pasek informacyjny i pasek zaufania zawijały się na kilka linii.
     Samą pętlę robi CSS (dwie identyczne grupy w __track + translateX(-50%)),
     tutaj są tylko dwie rzeczy, których CSS nie umie:
       (a) tempo liczone z szerokości grupy, żeby prędkość nie zależała od
           długości tekstów wpisanych w adminie,
       (b) pauza przy dotknięciu.
     Na desktopie grupa ma display: contents, więc nie ma boksu i offsetWidth
     wynosi 0 — wtedy nic nie ustawiamy, a animacji i tak nie ma. */
  var TICKER_SPEED = 55; /* px/s */

  function initTicker(inner) {
    var track = inner.firstElementChild;
    var group = track && track.firstElementChild;
    if (!group) return function () {};

    function applyDuration() {
      var w = group.offsetWidth;
      if (!w) return;
      inner.style.setProperty("--cs-ticker-dur", (w / TICKER_SPEED).toFixed(2) + "s");
    }
    function pause() { inner.classList.add("is-ticker-paused"); }
    function resume() { inner.classList.remove("is-ticker-paused"); }

    applyDuration();

    var ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(applyDuration) : null;
    if (ro) ro.observe(inner);
    CS.mobileMQ.addEventListener("change", applyDuration);

    inner.addEventListener("pointerdown", pause);
    inner.addEventListener("pointerup", resume);
    inner.addEventListener("pointercancel", resume);
    inner.addEventListener("pointerleave", resume);

    return function () {
      if (ro) ro.disconnect();
      CS.mobileMQ.removeEventListener("change", applyDuration);
      inner.removeEventListener("pointerdown", pause);
      inner.removeEventListener("pointerup", resume);
      inner.removeEventListener("pointercancel", resume);
      inner.removeEventListener("pointerleave", resume);
    };
  }

  CS.onSection("[data-cs-ticker]", initTicker);

  /* ---- podgląd zakresu: miejsce zależne od breakpointu -------
     Na mobile podgląd ma stać pod nagłówkiem „Zakres okien”, czyli WEWNĄTRZ
     formularza; na desktopie zostaje w lepkiej kolumnie galerii. To dwa różne
     kontenery, a `order` działa tylko między rodzeństwem — samym CSS-em się
     tego nie zrobi. Przenosimy więc jeden węzeł tam i z powrotem.

     Dlaczego nie druga kopia w HTML: cs-configurator.js bierze
     `root.querySelector("[data-cs-coverage]")`, czyli tylko pierwszy
     egzemplarz, więc drugi nigdy by się nie odświeżał.

     Przenosiny nie zrywają referencji trzymanych przez konfigurator —
     to wciąż ten sam element, zmienia się wyłącznie rodzic.

     ⚠ Rejestrujemy się na GNIEŹDZIE, nie na [data-cs-product]. `mounted`
     w cs-core.js to WeakMap kluczowany samym elementem, nie parą
     element+selektor, więc druga rejestracja na tym samym elemencie jest
     po cichu pomijana — a [data-cs-product] zajmuje już cs-configurator.js,
     ładowany wcześniej. Ten init nigdy by się nie wykonał. */
  function initCoveragePlacement(slot) {
    var root = slot.closest("[data-cs-product]");
    var box = root && root.querySelector(".cs-hero__coverage");
    if (!box) return function () {};
    var home = box.parentNode;            /* .cs-hero__gallery, stan wyjściowy */

    var lastW = -1;

    function place() {
      var target = CS.mobileMQ.matches ? slot : home;
      if (box.parentNode !== target) target.appendChild(box);
    }
    function onWidth(entries) {
      var w = entries && entries[0] ? Math.round(entries[0].contentRect.width) : root.clientWidth;
      if (w === lastW) return;   /* przenosiny zmieniają wysokość, nie szerokość — pętli RO nie ma */
      lastW = w;
      place();
    }

    place();

    /* TRZY niezależne wyzwalacze, celowo z nadmiarem. `place` jest idempotentne
       i kosztuje jedno porównanie, więc nadmiar nic nie kosztuje, a pomyłka
       kosztuje dużo: podgląd zostaje po niewłaściwej stronie breakpointu.
       (W podglądzie motywu nie odpala ani `change` na MQ, ani ResizeObserver —
       ten sandbox nie kręci pętli renderowania. Na normalnej przeglądarce
       odpalają wszystkie trzy.) */
    CS.mobileMQ.addEventListener("change", place);
    window.addEventListener("resize", place, { passive: true });
    var ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(onWidth) : null;
    if (ro) ro.observe(root);

    return function () {
      CS.mobileMQ.removeEventListener("change", place);
      window.removeEventListener("resize", place);
      if (ro) ro.disconnect();
    };
  }

  CS.onSection("[data-cs-coverage-slot]", initCoveragePlacement);

  /* ---- licznik koszyka --------------------------------------- */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        CS.$$("[data-cs-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { /* licznik nie jest krytyczny */ });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDelivery();
    initHeaderHeight();
    initStickyCta();
    initHeroGlow();
  });

  window.CSUi = { refreshCartCount: refreshCartCount, deliveryText: deliveryText };
})();
